<p>job-requests-group-qr-code works!</p>
